import React from 'react';
import './courses.css';
import { useNavigate } from 'react-router-dom';

const Courses = () => {
  const navigate = useNavigate();

  const courses = [
    {
      name: 'Java Full Stack',
      path: '/skillupgrade/courses/java',
      emoji: '☕',
      description: 'Master front-end & back-end Java technologies',
    },
    {
      name: 'Python Programming',
      path: '/skillupgrade/courses/python',
      emoji: '🐍',
      description: 'From basics to automation and web apps',
    },
    {
      name: 'AI/ML',
      path: '/skillupgrade/courses/ai',
      emoji: '🤖',
      description: 'Dive into Artificial Intelligence and Machine Learning',
    },
    {
      name: 'Data Structures & Algorithms',
      path: '/skillupgrade/courses/dsa',
      emoji: '🧠',
      description: 'Master coding interviews and logic building',
    },
    {
      name: 'DevOps',
      path: '/skillupgrade/courses/devops',
      emoji: '🛠️',
      description: 'Learn CI/CD, Docker, Kubernetes, and more',
    },
    {
      name: 'Data Science',
      path: '/skillupgrade/courses/datascience',
      emoji: '📊',
      description: 'Real-world data analysis and visualization',
    },
    {
      name: 'Frontend Development',
      path: '/skillupgrade/courses/frontend',
      emoji: '🌐',
      description: 'Learn HTML, CSS, JavaScript, React, and build interactive UIs',
    },
    {
      name: 'Backend Development',
      path: '/skillupgrade/courses/backend',
      emoji: '🖥️',
      description: 'Learn Node.js, Express, databases, APIs, and server-side logic',
    },
    {
      name: 'Testing & QA',
      path: '/skillupgrade/courses/testing',
      emoji: '🧪',
      description: 'Learn unit testing, integration testing, and QA best practices',
    },
  ];

  const handleEnroll = (courseName) => {
    navigate("/skillupgrade/enroll", { state: { courseName } });
  };

  return (
    <div className="courses-container">
      <h1 className="courses-title">📚 Our Courses</h1>
      <div className="courses-grid">
        {courses.map((course, index) => (
          <div key={index} className="course-card">
            <div className="icon">{course.emoji}</div>
            <h2>{course.name}</h2>
            <p>{course.description}</p>
            <button
              className="enroll-btn"
              onClick={() => handleEnroll(course.name)}
            >
              📝 Enroll Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Courses;
